'use strict';

angular.module('chatEngine.services', [
    'ngCookies',
    'chatEngine.configuration',
    'chatEngine.mixpanel'
])

.factory('messageService', ['sessionDataService', function(sessionDataService) {
    var services = {};

    // Converts a "frontend"-style message into an array of messages that can be sent to the backend.
    services.messageToArray = function(message) {
        if(!message) {
            return [];
        }

        var array = [];
        var kowData = sessionDataService.getCurrentBotData();

        if(message.body) {
            array.push({
                type: 'text' ,
                body: message.body
            });
        }
        // We have to rely on message.type because it is totally possible to have both picUrl and url fields set.
        if(message.type === 'gallery' && message.picUrl) {
            array.push({
                type: 'gallery',
                picUrl: message.picUrl
            });
        } else if(message.type === 'plain-web' && message.url) {
            array.push({
                type: 'plain-web',
                url: message.url
            });
        } else if(message.type === 'kik-optimized-web') {
            array.push({
                type: 'kik-optimized-web',
                title: message.title,
                url: message.url  || kowData.kow_url,
                appName: message.appName || kowData.kow_title,
                text: message.text,
                picUrl: message.kowPicUrl,
                iconUrl: message.iconUrl || kowData.kow_icon,
                big: Boolean(message.big),
                data: JSON.parse(message.data)
            });
        }

        // Let's clean up by removing null values
        for(var i = 0; i < array.length; i++) {
            for(var key in array[i]) {
                if(array[i][key] === null) {
                    delete array[i][key];
                }
            }
        }

        return array;
    };

    // Converts a "backend"-style array of messages into a single message
    // object that can be used on the frontend.
    services.arrayToMessage = function(array) {
        var message = {
            'body': null,
            'type': 'text',
            'title': null,
            'appName': null,
            'text': null,
            'picUrl': null,
            'big': null,
            'iconUrl': null,
            'data': null,
            'noForward': null,
            'url': null,
            'kowPicUrl': null
        };

        for(var i = 0; array && i < array.length; i++) {
            if(array[i].type === 'gallery') {
                message.type = 'gallery';
                message.picUrl = array[i].picUrl;
            } else if(array[i].type === 'plain-web') {
                message.type = 'plain-web';
                message.url = array[i].url;
            } else if(array[i].type === 'kik-optimized-web') {
                message.type = 'kik-optimized-web';
                message.appName = message.title = array[i].appName || null;
                message.url = array[i].url || null;
                message.picUrl = array[i].picUrl || null;
                message.iconUrl = array[i].iconUrl || null;
                message.text = array[i].text || null;
                message.big = Boolean(array[i].big);
                message.data = JSON.stringify(array[i].data) || null;
                message.kowPicUrl = array[i].picUrl || null;
            }
            message.body = message.body || array[i].body || null;
        }

        return message;
    };

    // Convert a list of backend-style arrays of messages to
    // frontend-style messages.
    services.arraysToMessages = function(arrays) {
        var messages = [];
        for(var i = 0; arrays && i < arrays.length; i++) {
            messages.push(services.arrayToMessage(arrays[i]));
        }
        return messages;
    };

    // Convert a list of frontend-style messages to a list of backend-style
    // messages.
    services.messagesToArrays = function(messages) {
        var arrays = [];
        for(var i = 0; i < messages.length; i++) {
            arrays.push(services.messageToArray(messages[i]));
        }
        return arrays;
    };

    services.getDefaultMessageFormat = function() {
        return {
            body: '',
            type: 'text',
            title: null,
            url: null,
            appName: null,
            text: null,
            picUrl: null,
            big: null,
            iconUrl: null,
            data: null,
            noForward: null
        };
    };

    return services;
}])

.factory('imageUploadService', ['$q', '$http', function($q, $http) {
    var MAX_FILE_SIZE = 10 * (1 << 20);
    var SUPPORTED_TYPES_REGEX = /^image\/png|jpeg$/;
    var DEFAULT_ENDPOINT = '/api/v1/upload/image';
    var ERRORS = {
        unsupported: {
            message: 'Image file must be either a jpeg (jpg) or png.'
        },
        maxSize: {
            message: 'Image file must be 10MB or less.'
        },
        httpError: {
            message: 'Please check your connection and try again later.'
        },
        invalidDimensions: {
            message: 'Invalid dimensions'
        }
    };

    function upload(file, endpoint, options) {
        endpoint = endpoint || DEFAULT_ENDPOINT;
        options = options || {};
        var dfd = $q.defer();

        if (!SUPPORTED_TYPES_REGEX.test(file.type)) {
            dfd.reject(ERRORS.unsupported);
        } else if (file.size > MAX_FILE_SIZE) {
            dfd.reject(ERRORS.maxSize);
        } else {
            var reader = new FileReader();
            reader.onload = function(event) {
                var data = event.target.result;

                var image = angular.element('<img />');
                image.bind('load', function() {
                    // Check dimensions
                    if(options.width && this.width !== options.width ||
                        options.height && this.height !== options.height) {
                        dfd.reject(ERRORS.invalidDimensions);
                        return;
                    }

                    // Dimensions are good, let's upload it
                    $http.post(endpoint, {data: data})
                        .success(function(data) {
                            dfd.resolve(data);
                        })
                        .error(function(data) {
                            dfd.reject(data.message ? data : ERRORS.httpError);
                        });
                });
                image.attr('src', event.target.result);
            };
            reader.readAsDataURL(file);
        }

        return dfd.promise;
    }

    return {
        upload: upload
    };
}])

/**
 * Mixpanel service used to track events
 * Adds bot id to event properties
 * Queues up events until bot id is available
 **/

.factory('mixpanelService', ['$rootScope', '$window', 'sessionDataService',
    function($rootScope, $window, sessionDataService) {
    var services = {};
    var queue = [];
    var identitySet;

    services.init = function() {
        identitySet = setMixpanelIdentity();
    };

    services.track = function(eventName, data) {
        // Tracks an event if the identity has been set, otherwise queues it
        if (!data) {
            data = {};
        }
        var botId = sessionDataService.getCurrentBotId();
        if (!botId) {
            queue.push([eventName, data]);
        } else {
            if (!identitySet) {
                identitySet = setMixpanelIdentity();
            }
            if(identitySet) {
                data.bot_id = botId;
                data.username = sessionDataService.getKikUsername();
                data.auth_type = data.username ? 'kik' : 'email';
            }
            services.forceTrack(eventName, data);
        }
    };

    services.forceTrack = function(eventName, data) {
        // Tracks an event, even if the identity hasn't been set yet
        $window.mixpanel.track(eventName, data);
    };

    $rootScope.$on('sessionDataUpdated', function() {
        if (sessionDataService.getCurrentBotId()) {
            identitySet = setMixpanelIdentity();

            //Clean up queue
            while (queue.length > 0) {
                var ev = queue.shift();
                services.track(ev[0], ev[1]);
            }
        }
    });

    function setMixpanelIdentity() {
        var botId = sessionDataService.getCurrentBotId();
        if (botId) {
            $window.mixpanel.identify(botId);
            return true;
        }
        return false;
    }

    return services;
}])

/**
 * Config Data Service: use to share config data across controllers without polluting the rootScope
 * Broadcasts down an 'sessionDataUpdated' event when setSessionData is called
 *
 * TODO make into general dataService when needed
 **/

.factory('sessionDataService', ['$rootScope', '$http', function($rootScope, $http) {
    var sessionData = {};
    var services = {};

    services.isInitialized = function() {
        return !!sessionData.username;
    };

    services.setSessionData = function(data) {
        sessionData = data;
        $rootScope.$broadcast('sessionDataUpdated');
    };

    services.getSessionData = function() {
        return sessionData;
    };

    services.getCurrentBotId = function() {
        return sessionData.current_bot || null;
    };

    services.getKikUsername = function() {
        return sessionData.username || null;
    };

    services.getCurrentBotData = function() {
        if (!sessionData.bots || !sessionData.current_bot) {
            return {};
        }
        for (var i = 0; i < sessionData.bots.length; i++) {
            if (sessionData.bots[i].id === sessionData.current_bot) {
                return sessionData.bots[i];
            }
        }
        return {};
    };

    services.init = function() {
        sessionData = {};
        $http.get('/api/v1/session')
        .success(function(data) {
            services.setSessionData(data);
        })
        .error(function() {
            $rootScope.$broadcast('sessionDataFailed');
        });
    };

    services.clear = function() {
        sessionData = {};
    };

    return services;
}])

.factory('socketService', ['$rootScope', 'firebase', 'mixpanelService', 'DEBUG', 'FIREBASE_API_KEY',
    'FIREBASE_AUTH_DOMAIN', 'FIREBASE_DATABASE_URL', 'FIREBASE_STORAGE_BUCKET', 'FIREBASE_MESSAGING_SENDER_ID',
    function($rootScope, firebase, mixpanelService, DEBUG, FIREBASE_API_KEY, FIREBASE_AUTH_DOMAIN,
        FIREBASE_DATABASE_URL, FIREBASE_STORAGE_BUCKET, FIREBASE_MESSAGING_SENDER_ID) {
        return {
            database: null,
            socketRef: null,

            _attachListener: function(socketId) {
                this.socketRef = this.database.ref('kikcodes/' + socketId);

                this.socketRef.on('value', function(message) {
                    var messageData = message.val();

                    if (messageData && messageData.status) {
                        $rootScope.$broadcast(messageData.status, messageData);
                    } else if (messageData) {
                        mixpanelService.forceTrack('Login Socket Message Missing Status Field', {
                            socketMessage: messageData
                        });
                        $rootScope.$broadcast('socketError');
                    }
                });
            },

            _disableSocket: function() {
                if (!this.socketRef) {
                    return false;
                }

                this.socketRef.off();
                this.socketRef = null;

                return true;
            },

            _disableApp: function() {
                if (!this.database) {
                    return false;
                }

                this.database.app.delete();
                this.database = null;

                return true;
            },

            init: function(socketId, socketToken) {
                if (this.database || this.socketRef) {
                    this.closeSocket();
                }

                // Use a random string as the name of the app to prevent name collision when asynchronously
                // closing and initializing Firebase apps.
                this.database = firebase.initializeApp({
                    apiKey: FIREBASE_API_KEY,
                    authDomain: FIREBASE_AUTH_DOMAIN,
                    databaseURL: FIREBASE_DATABASE_URL,
                    storageBucket: FIREBASE_STORAGE_BUCKET,
                    messagingSenderId: FIREBASE_MESSAGING_SENDER_ID
                }, Math.random().toString()).database();

                if (DEBUG) {
                    this._attachListener(socketId);
                } else {
                    this.database.app.auth().signInWithCustomToken(socketToken).then(function() {
                        this._attachListener(socketId);
                    }.bind(this), function() {
                        $rootScope.$broadcast('socketError');
                    });
                }
            },

            closeSocket: function() {
                var socketDisabled = this._disableSocket();
                var appDisabled = this._disableApp();
                return socketDisabled && appDisabled;
            }
        };
    }
])

.factory('authService', ['$window', '$http', '$cookies', 'DEBUG', 'KIK_ENGINE_KEY',
    function($window, $http, $cookies, DEBUG, KIK_ENGINE_KEY) {
    var services = {},
        kikUsername = null;

    services.checkAuthCookie = function() {
        return $cookies.get(KIK_ENGINE_KEY);
    };

    services.setEngineCookie = function(cookie) {
        var setSecure = '; secure';
        if (DEBUG) {
            setSecure = '';
        }
        //HAX: can't use angular's $cookies here as it URI encodes cookie values
        $window.document.cookie = KIK_ENGINE_KEY + '=' + cookie + '; path=/' + setSecure;
    };

    services.clearAuthCookies = function() {
        $cookies.remove(KIK_ENGINE_KEY, {path: '/'});
    };

    return services;
}])

.factory('kikService', ['$window', function($window) {
    return $window.kik || {};
}])

.factory('FastClickService', ['$window', function($window) {
    return $window.FastClick || {};
}])

.factory('storageService', ['$window', function($window) {
    var services = {};
    var fakeStorage = {};
    var useFake = false;

    services.setItem = function(key, value) {
        if (useFake) {
            fakeStorage[key] = value;
        } else {
            try {
                $window.sessionStorage.setItem(key, value);
            } catch (e) {
                useFake = true;
                fakeStorage[key] = value;
            }
        }
    };

    services.getItem = function(key) {
        if (useFake) {
            return fakeStorage[key];
        }
        return $window.sessionStorage.getItem(key);
    };

    services.removeItem = function(key) {
        if (useFake) {
            delete fakeStorage[key];
        } else {
            $window.sessionStorage.removeItem(key);
        }
    };

    return services;
}])

.factory('externalLinkService', ['mixpanelService', function(mixpanelService) {
    var services = {};

    services.externalLink = function(eventName, pageLocation) {
        mixpanelService.forceTrack(eventName, {
            location: pageLocation
        });
    };

    return services;
}])

.factory('alertService', [function() {
    var alertData = {
        'showAppleIdAlert': false
    };
    var services = {};

    services.setShowAppleIdAlert = function(show) {
        alertData.showAppleIdAlert = show;
    };

    services.getAlertData = function() {
        return alertData;
    };

    return services;
}]);
